import { HOST } from "../constants/HostConstants";

export const adminRevokeKeys = async (
  user_id,
  email_address,
  amount,
  reason,
) => {
  try {
    const res = await fetch(`${HOST}/api/transaction/adminRevokeKeys`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ user_id, email_address, amount, reason }),
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    if (!res.ok) return { success: false, error: data?.error || "Failed" };
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.message };
  }
};
